import { render } from "./VideoSettings.vue?vue&type=template&id=a77d0500"
import script from "./VideoSettings.vue?vue&type=script&lang=js"
export * from "./VideoSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__